import { Material, ProductType } from '~/supabase/types'

type TranslationMap = Record<Material | 'diamond', string>
const materialsTranslationMap: { cs: TranslationMap; en: TranslationMap } = {
  cs: {
    diamond: 'Diamant',
    rose_gold: 'Zlato',
    white_silver: 'Stříbro',
    rose_diamond: 'Diamant',
    yellow_diamond: 'Diamant',
    white_diamond: 'Diamant',
    moldavite_gemstone: 'Vltavín',
    garnet_gemstone: 'Granát',
  },
  en: {
    diamond: 'Diamond',
    rose_gold: 'Gold',
    white_silver: 'Silver',
    rose_diamond: 'Diamond',
    yellow_diamond: 'Diamond',
    white_diamond: 'Diamond',
    moldavite_gemstone: 'Moldavite gemstone',
    garnet_gemstone: 'Garnet gemstone',
  },
}

const categoriesTranslationMap = {
  cs: {
    ring: 'Prsten',
    earring: 'Náušnice',
    pendant: 'Přívěšek',
    necklace: 'Náhrdelník',
    bracelet: 'Náramek',
    gemstone: 'Drahokam',
    chain: 'Žetona',
  },
  en: {
    ring: 'Ring',
    earring: 'Earring',
    pendant: 'Pendant',
    necklace: 'Necklace',
    bracelet: 'Bracelet',
    gemstone: 'Gemstone',
    chain: 'Chain',
  },
}

export type GetProductDetailPageTitleParams = {
  material: Material
  product_type: ProductType
  id: number
  locale: 'en' | 'cs'
}

export const getProductDetailPageTitle = ({
  material,
  product_type,
  id,
  locale,
}: GetProductDetailPageTitleParams) => {
  const translatedMaterial = materialsTranslationMap[locale][material]
  const translatedCategory = categoriesTranslationMap[locale][product_type]
  const czech = `Šperky s granáty ${translatedMaterial} ${translatedCategory} - ${id}`
  const english = `Garnet ${translatedMaterial} ${translatedCategory} - ${id}`

  return locale === 'en' ? english : czech
}

const SLUG_ID_SEPARATOR = '_'
const PREFIX = 'garnet'

const materialSlugMap: Record<Material, string> = {
  white_diamond: 'white-gold-with-diamond',
  yellow_diamond: 'yellow-gold-with-diamond',
  rose_diamond: 'rose-gold-with-diamond',
  rose_gold: 'rose-gold',
  white_silver: 'silver',
  moldavite_gemstone: 'moldavite-gemstone',
  garnet_gemstone: 'garnet-gemstone',
}

export type GetProductDetailSlugParams = {
  material: Material
  product_type: ProductType
  id: number
}

export const getProductDetailSlug = ({ product_type, material, id }: GetProductDetailSlugParams) =>
  `${materialSlugMap[material]}-${PREFIX}-${product_type}${SLUG_ID_SEPARATOR}${id}`
